// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SetupFee_ComprovanteArquivoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** GET /subscriptions/setup-fee/comprovante-arquivo/:id — link temporário (1 h) para o arquivo. */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SetupFee_ComprovanteArquivoResponseDados {
url: string
nome: string
}

export type SetupFee_ComprovanteArquivoResponse = ApiResponse<SetupFee_ComprovanteArquivoResponseDados>;

registerResponseContract('SetupFee_ComprovanteArquivoResponse', {
  url:  { type: 'string',  required: true },
  nome: { type: 'string',  required: true },
})
